export default __webpack_public_path__ + "static/media/surf_w.0b31b3fe.svg";